import {BaseEvent} from "./BaseEvent";

export class EditChartEvent extends BaseEvent {
  public static NAME = 'editChart';

  constructor() {
    super(EditChartEvent.NAME);
  }
}
